import { format } from "date-fns";
import { getFrontDomain } from "utils/api";

class LatestNewsService {
  static getLatestNews = async (location = "") => {
    let url = `${getFrontDomain()}/api/news/latest`;

    if (location) {
      url += `/${location}`;
    }

    const response = await fetch(url, {
      method: "GET",
      credentials: "same-origin",
    });

    return response.json();
  };

  static getLatestNewsByDay = async (timestamp) => {
    const day = format(new Date(+timestamp), "DD-MM-YYYY");
    const response = await fetch(`${getFrontDomain()}/api/news/daily/${day}`, {
      method: "GET",
      credentials: "same-origin",
    });

    return response.json();
  };

  static getLatestNewsByMonth = async (month) => {
    const response = await fetch(
      `${getFrontDomain()}/api/news/monthly/${month}`,
      {
        method: "GET",
        credentials: "same-origin",
      }
    );

    return response.json();
  };
}

export default LatestNewsService;
